import React from 'react'
import { ContactCard } from '../ContactCard'
import { ISocietyContactModel } from '../../../interfaces/models/society-contacts.interfaces'

interface ContactListProps {
  contacts: ISocietyContactModel[]
  management: boolean
}

export const ContactList = ({
  contacts,
  management,
}: ContactListProps): JSX.Element => {
  return (
    <div className="flex flex-row flex-wrap gap-8 pb-4">
      {contacts.map((contact) => (
        <ContactCard
          key={contact._id}
          contact={contact}
          management={management}
        />
      ))}
    </div>
  )
}
